import { apiRequest, getAccessToken, API_BASE } from './client'
import { Branding } from '../../types/branding'

async function uploadFile(path: string, file: File): Promise<{ url: string }> {
  const token = getAccessToken()
  const headers: Record<string, string> = {
    'Content-Type': file.type || 'application/octet-stream',
  }
  if (token) headers['Authorization'] = `Bearer ${token}`
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers,
    body: file,
    credentials: 'include',
  })
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Upload failed' }))
    throw new Error(error.error || `Upload error: ${response.status}`)
  }
  return response.json()
}

export const brandingApi = {
  async getMe(): Promise<Branding | null> {
    const response = await apiRequest<{ branding: Branding | null }>('/branding/me')
    return response.branding
  },

  async getForOrg(orgId: string): Promise<Branding> {
    const response = await apiRequest<{ branding: Branding }>(`/admin/orgs/${orgId}/branding`)
    return response.branding
  },

  async update(orgId: string, data: Partial<Branding>): Promise<Branding> {
    const response = await apiRequest<{ branding: Branding }>(`/admin/orgs/${orgId}/branding`, {
      method: 'PATCH',
      body: data,
    })
    return response.branding
  },

  async uploadLogo(orgId: string, file: File): Promise<{ url: string }> {
    return uploadFile(`/admin/orgs/${orgId}/branding/logo`, file)
  },

  async uploadLogoDark(orgId: string, file: File): Promise<{ url: string }> {
    return uploadFile(`/admin/orgs/${orgId}/branding/logo-dark`, file)
  },

  async uploadFavicon(orgId: string, file: File): Promise<{ url: string }> {
    return uploadFile(`/admin/orgs/${orgId}/branding/favicon`, file)
  },

  async deleteLogo(orgId: string): Promise<void> {
    await apiRequest(`/admin/orgs/${orgId}/branding/logo`, { method: 'DELETE' })
  },

  async deleteLogoDark(orgId: string): Promise<void> {
    await apiRequest(`/admin/orgs/${orgId}/branding/logo-dark`, { method: 'DELETE' })
  },
}
